"use client";
import { Stack, Flex, Image } from "@chakra-ui/react";
import ElasticArchitectureImg from "public/application-services/elastic-architecture.png";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import { ELK_STACK_CONSTANTS } from "./constants";

const ArchitectureComponent = () => {
  const textVariant = useTextVariant();
  const { title, subTitle, text } = ELK_STACK_CONSTANTS;

  return (
    <Flex
      direction={{ base: "column", xl: "row" }}
      align={"center"}
      justify={"center"}
      px={8}
      mt={-16}
      gap={8}
    >
      <Stack
        gap={6}
        width={{ base: "100%", xl: "40%" }}
        align={{ base: "center", xl: "flex-start" }}
        textAlign={{ base: "center", xl: "left" }}
      >
        <Heading as="h1" fontWeight={"400"} fontSize={"44px"}>
          {title}
        </Heading>
        <Text variant={textVariant} fontWeight={600} color="text.100">
          {subTitle}
        </Text>
        <Text variant={textVariant} color="text.100" lineHeight={"30px"}>
          {text}
        </Text>
      </Stack>

      <Stack width={{ base: "100%", xl: "60%" }} justify={"center"} align={"center"}>
        <Image
          src={ElasticArchitectureImg.src}
          alt="Architecture Diagram"
          style={{
            height: "auto",
            maxWidth: "1000px",
            width: "100%",
            maxHeight: "600px",
            objectFit: "contain",
          }}
        />
      </Stack>
    </Flex>
  );
};

export default ArchitectureComponent;
